import { createStore , applyMiddleware , compose  } from 'redux';
import {reducers} from './reducers/reducers'
import Sagas from "./sagas";
import createSagaMiddleware from 'redux-saga';

function startStatePrepear(state) {
	return state;
}

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;

const Storage = createStore(
	reducers,
	{
		active : false,
		gloopsOptions : {},
		activeGloop : false,
		//activeScreen : 'gloop',
		activeScreen : 'start',
		error : '',
		videoVersion : 0
	},
	composeEnhancers(applyMiddleware(sagaMiddleware))
	// window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);


sagaMiddleware.run(Sagas);

//Storage.dispatch({type: 'USER_FETCH_REQUESTED', payload: {userId: 22}})
//Storage.dispatch({type: 'USER_FETCH_REQUESTED2', payload: {userId: 222222}})
export default Storage;
